import React, { Fragment, useState } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { useAlert } from 'react-alert';

import withClass from '../../../hoc/withClass';
import errorHandler from '../../../hoc/ErrorHandler';
import SystemCopyright from '../../../components/UI/SystemCopyright/SystemCopyright';
import Credentials from './Forms/Credentials/Credentials';
import eBoardLogo from '../../../assets/images/eboard-logo.png';

const ForgotPassword = props => {
    document.body.className = "page-forgot-password layout-full";
    const alert = useAlert();
    const [password, setPassword] = useState(null);

    const createPasswordHandler = async event => {
        event.preventDefault();
        
        const response = await axios.patch('/users/password', {userName: props.match.params.username, initialPassword: props.match.params.initial_password, newPassword: password}, {headers: {
            'Company-Code': props.match.params.code,
            'Company-Id': props.match.params.company_id
        }});

        if(response) 
            return alert.show(response.data.message, {type: 'success'});
    };

    const userPasswordChangeHandler = (password, isValid) => {
        if(!isValid) 
            return setPassword(null);

        if(password.length === 0) 
            return setPassword(null);

        return setPassword(password);
    };

    return (
        <Fragment>
            <div className="page-content vertical-align-middle">
                <img src={eBoardLogo} alt="eBoard Logo" className="img-fluid mx-auto d-block" style={{width: '200px', height: '70px', margin: '10px auto'}} />
                <h2>Create Account Password</h2>
                <div className="alert alert-warning">
                    <i className="icon fa-warning" aria-hidden="true"></i>&nbsp;Do not disclose your password to anyone!
                </div>
                <Fragment>
                    <Credentials userPasswordChangeHandler={(password, isValid) => userPasswordChangeHandler(password, isValid)} createPasswordHandler={createPasswordHandler} password={password} />
                    <SystemCopyright forgotPassword />
                </Fragment>
            </div>
        </Fragment>
    );
};

export default withRouter(errorHandler(withClass(ForgotPassword, 'page vertical-align text-center'), axios));